import * as yup from 'yup';
import { EMAIL_REGEXP, LETTERS_REGEXP } from '../../../utils/validate';
import { t } from '@transifex/native';

export const addBrandInfoValidationSchema = yup.object().shape({
  billingEmail: yup
    .string()
    .required('Billing email address is a required field')
    .matches(EMAIL_REGEXP, 'Email must be in e-mail format'),
  legalName: yup
    .string()
    .required('Legal name is a required field')
    .min(3, t('Minimum length should be 3 chars')),
  addressLineFirst: yup
    .string()
    .required('Address is a required field')
    .min(2, 'Minimum length should be 2 chars')
    .max(50, 'Maximum length should be 50 chars'),
  addressLineSecond: yup.lazy((value) => {
    if (value.length > 0) {
      return yup
        .string()
        .min(2, 'Minimum length should be 2 chars')
        .max(50, 'Maximum length should be 50 chars');
    }
    return yup.string().notRequired();
  }),
  city: yup
    .string()
    .required('City is a required field')
    .min(2, 'Minimum length should be 2 chars')
    .max(50, 'Maximum length should be 50 chars'),
  postCode: yup
    .string()
    .required('Postcode is a required field')
    .min(2, 'Minimum length should be 2 chars')
    .max(50, 'Maximum length should be 50 chars'),
  brandCountryCode: yup
    .string()
    .required('Brand country code is a required field')
    .matches(LETTERS_REGEXP, 'Country code should only contain letters')
    .min(2, 'Minimum length should be 2 chars')
    .max(50, 'Maximum length should be 50 chars'),
  brandType: yup.string().required(t('Brand type is required')).min(1, t('Brand type is required')),
});
